import { IframeWindow } from '@ps/bridge/iframe/iframe.window.type'
import { IGlobalConfigBg } from '@ps/bridge/qc/scripts/bg-config'
import router from '@ps/router'
import store from '@ps/store'
import { getAudioInfoByUrl } from '@ps/utils/tools'
import { projectBasicPath } from '@ps/workbench/config'
import { copyFile } from '@ps/api/editor/file'
import filepath from '@ps/bridge/path'
import { findTargetResource } from '@ps/bridge/resource'

const pathConfig = {
  bgm: `${filepath.AUDIO_BASIC_PATH}bm_bgm_origin.mp3`
}

/**
 * 查找素材包中的背景音乐，有的话将其该音乐的信息添加到 ps.GlobalConfigBg 脚本中
 */
export async function adaptBgmWhenGameReady({
  iframeWindow,
  globalConfig
}: {
  iframeWindow: IframeWindow
  globalConfig: IGlobalConfigBg
}): Promise<boolean> {
  console.log('查找背景音乐，有的话并将其该音乐的信息添加到 ps.GlobalConfigBg 脚本中')

  const projectId = Number(router.currentRoute.query.id)
  // 查找是否有bm_bgm.mp3文件
  const res = await store.dispatch('workspace/resource/getProjectResource', {
    projectKey: projectId
  })
  // 接口返回的链接是以 / 开头的
  const bgmUrl = findTargetResource(res.data.result, name =>
    /\/bm_bgm\.mp3$/.test(name)
  )

  if (bgmUrl) {
    // 获取当前背景音乐的 meta 信息
    const audioInfo = await getAudioInfoByUrl(
      `${projectBasicPath}${projectId}${bgmUrl}`
    )
    if (audioInfo) {
      globalConfig.bgmSourceAudioDuration = audioInfo.duration * 1000
      globalConfig.bgmSourceAudioUrl = pathConfig.bgm
      globalConfig.bgmAudioUrl = bgmUrl
      globalConfig.bgmSize = audioInfo.length
    }

    // 复制一份原始资源，保证音频裁切时使用到裁切之前的资源
    const destBgmCopyPath = pathConfig.bgm
    await copyFile({
      pid: projectId,
      src: bgmUrl,
      dst: destBgmCopyPath,
      overwrite: 1
    })
    const originAudioResource = `${projectBasicPath}${projectId}/${pathConfig.bgm}`
    await store.dispatch('workspace/editorConfig/updateTargetNodeConfig', {
      originalResource: originAudioResource,
      resource: originAudioResource,
      bgm: true
    })
    store.commit('workspace/globalConfig/updateBgmUrl', { url: bgmUrl })
    // 同步新的背景音乐到 bgmConfig 中
    store.commit('workspace/game/bgm/setCurrentBgmConfig')
    return true
  }
  console.log('==================== 没有找到背景音乐')
  return false
}
